<template>
  <v-form ref="mainForm" v-model="valid">
    <data-iterator
      :list="sas.equivalencesFormationsContinues"
      add-new-text="Ajouter une formation continue"
      :live="{ endpoint: 'sas-equivalence-formation-continue', sasId: sas.id }"
      :icon="$getIcon('formationContinue')"
      optional
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.titre }}</h3>
        <p class="my-0">{{ item.nombreHeures }} h</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-text-field code="titre-formation" v-model="item.titre" :live="liveSasFormationContinue(7302, item)"></opq-text-field>
        <opq-text-field
          code="nombre-heures-formation"
          v-model="item.nombreHeures"
          :live="liveSasFormationContinue(7303, item)"
          isNumber
        ></opq-text-field>
        <opq-memo code="description-formation" v-model="item.descriptionDeLActivite" :live="liveSasFormationContinue(7304, item)"></opq-memo>
        <opq-file-multiple
          code="fichier-description-formation"
          :files="item.fichierDescription"
          :live="liveSasFormationContinue(7305, item)"
        ></opq-file-multiple>
        <opq-file-multiple
          code="attestation-formation"
          :files="item.attestationDeParticipation"
          :live="liveSasFormationContinue(7306, item)"
        ></opq-file-multiple>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasFormationContinue(cle, item) {
      return { endpoint: "sas-equivalence-formation-continue", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>